import React from 'react'

import { useTranslation } from 'language/translator'

import Collapse from 'components_new/atoms/Collapse'
import Grid from 'components_new/atoms/Grid'

import CardOption from 'components_new/molecules/CardOption'

import { RollingType } from 'types/GlobalKpiOption'
import type { Step } from '../lib'
import { ISelectMetric } from 'types/GlobalMetric'

interface Props {
  step: Step
  metric: ISelectMetric
  rollingSum: RollingType | null
  setRollingSum: (v: RollingType | null) => void
}

const RollingSumStep = ({ step, metric, rollingSum, setRollingSum }: Props) => {
  const { t, translateEnum } = useTranslation()

  if (metric.rolling_sums.length === 0) return null

  return (
    <Collapse in={step === 'rollingSum'}>
      <Grid container={true} spacing={1}>
        <Grid item={true} xs={4}>
          <CardOption
            id={null}
            title={t('global', 'none')}
            active={rollingSum === null}
            onChange={() => setRollingSum(null)}
            sx={{ height: '100%', opacity: 0.5 }}
          />
        </Grid>
        {metric.rolling_sums.map((c) => (
          <Grid item={true} key={c} xs={4}>
            <CardOption
              id={c}
              active={rollingSum === c}
              title={translateEnum('rolling_types', c).abbreviation}
              body={translateEnum('rolling_types', c).title}
              variant={c === RollingType.R12 ? 'recommended' : undefined}
              onChange={() => setRollingSum(c as RollingType)}
              sx={{ height: '100%' }}
            />
          </Grid>
        ))}
      </Grid>
    </Collapse>
  )
}

export default RollingSumStep
